import { IAddFileResponse } from '../../../repositories/encrypted-file-manager/entities/Models/AddFileResponse';
import { IAttachedDocument, EAttachedDocumentType } from '../../../types/requestFormValue';

export const mapEncryptedFileToAttachedDocument = (file: IAddFileResponse): IAttachedDocument => {
  return {
    id: file.id,
    hash: file.fileHash as unknown as string,
    name: file.fileName,
    signature: file.idSignature as unknown as string,
    size: file.fileSize,
    type: EAttachedDocumentType.Temporary,
  };
};
